// extracted by mini-css-extract-plugin
module.exports = {"Contact":"Contact_Contact__akU86","Header":"Contact_Header__waNye"};